// extracted by mini-css-extract-plugin
export default {"productGrid":"i1-z","centerLink":"j1-z","productSection":"k1-z","item":"l1-z","ctaButton":"m1-z"};